import React from 'react';
import { FaTrophy, FaRocket, FaChartLine, FaVideo, FaUsers, FaPalette, FaArrowRight } from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      icon: <FaTrophy className="text-tiktok-red" size={40} />,
      title: 'صانع المحتوى المتخصص 🏆',
      description: 'نبني هوية قوية لحسابك ونسيطر على niche معين بخوارزميات ذكية واستراتيجية محتوى يومية.',
      features: ['استراتيجية محتوى', 'SEO للتيك توك', 'بناء مجتمع']
    },
    {
      icon: <FaRocket className="text-tiktok-cyan" size={40} />,
      title: 'حملات الانطلاق 💥',
      description: 'نصنع لك لحظات لا تُنسى ونحقق انتشاراً هائلاً بحملات إبداعية مدروسة.',
      features: ['إعلانات ممولة', 'تحديات فيروسية', 'إنتاج محتوى']
    },
    {
      icon: <FaChartLine className="text-tiktok-red" size={40} />,
      title: 'نظام اختبار الأداء 💰',
      description: 'إطار عمل يعتمد على البيانات لتحقيق أعلى عائد استثماري من المحتوى.',
      features: ['تحليلات متقدمة', 'A/B Testing', 'تقارير أداء']
    },
    {
      icon: <FaVideo className="text-tiktok-cyan" size={40} />,
      title: 'إنتاج محتوى احترافي',
      description: 'من الفكرة إلى التنفيذ، ننتج فيديوهات احترافية تليق بعلامتك التجارية.',
      features: ['تصوير ومونتاج', 'كتابة سيناريو', 'مؤثرات بصرية']
    },
    {
      icon: <FaUsers className="text-tiktok-red" size={40} />,
      title: 'إدارة الحسابات',
      description: 'ندير حساباتك بشكل كامل: جدولة، تفاعل، متابعة يومية.',
      features: ['نشر يومي', 'رد على التعليقات', 'إدارة الأزمات']
    },
    {
      icon: <FaPalette className="text-tiktok-cyan" size={40} />,
      title: 'بناء الهوية البصرية',
      description: 'نصمم لك هوية فريدة تميزك عن الملايين.',
      features: ['شعار', 'ألوان', 'خطوط', 'قوالب فيديوهات']
    }
  ];

  return (
    <section id="services" className="py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <span className="badge bg-tiktok-cyan text-black px-3 py-2 mb-3">SOLUTIONS</span>
          <h2 className="display-5 fw-bold mb-3">حلولنا المتكاملة</h2>
          <p className="lead text-secondary">من أول سكرول لآخر عملية شراء، احنا معاك</p>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="card h-100 border-0 shadow-sm hover-scale">
                <div className="card-body p-4">
                  <div className="mb-4">
                    {service.icon}
                  </div>
                  <h4 className="card-title mb-3">{service.title}</h4>
                  <p className="card-text text-secondary mb-4">{service.description}</p>
                  <ul className="list-unstyled mb-4">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="mb-2">
                        <span className="text-tiktok-cyan me-2">✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <a href="#contact" className="text-decoration-none fw-bold text-tiktok-red">
                    اكتشف المزيد <FaArrowRight className="ms-2" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <p className="lead">عندك فكرة مختلفة؟ <a href="#contact" className="text-tiktok-cyan fw-bold">تكلم معانا</a></p>
        </div>
      </div>
    </section>
  );
};

export default Services;